<template>
    <div class="modal fade history-filter-modal forgetwithdrawModal-cl" id="newUserWithDrawPasswordModel" data-bs-backdrop="static" 
        data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="thm-heading">
                        <p class="para-three">Forgot Withdraw Password</p>
                    </div>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="resetWithdrawForm"></button>
                </div>
                <div class="modal-body">
                    <div class="withdraw-password-update">
                        <div class="otp-msg-show">{{ $t('otp-sent-to', 'OTP sent to') }} <strong>****** {{ $auth.user.phone?.slice(-4) }}</strong>.</div>
                        <div class="withdraw-instruction">
                            <p class="para-four">{{ $t('withdraw-instruction', 'Withdraw Instruction') }}</p>
                            <ul>
                                <li>{{ $t('withdraw-password-eight-twenty', 'Withdraw Password Must be of minimum 8 characters and maximum 20 characters required') }}</li>
                                <li>{{ $t('withdraw-password-small-capital', 'Withdraw Password Must have atleast 1 small and 1 capital alphabet') }}</li>
                                <li>{{ $t('withdraw-password-digit-special-char', 'Withdraw Password Must have atleast 1 Digit and 1 Special character') }}</li>
                                <li>{{ $t('please-take-note-your-withdraw-password', 'Please take a note of your Withdraw Password') }}</li>
                            </ul>
                        </div>
                       <div class="back-modal">
                            <div class="number-header mb-3">
                                <label for="">{{ $t('withDraw-password-otp','OTP') }}*</label>
                                <div class="fill_con">
                                    <input type="tel" v-model="withdraw.passwordOtp"  placeholder="Enter OTP" class="form-control" maxlength="6"
                                        @input="withdraw.passwordOtp = $helper.sanitizeNumber(withdraw.passwordOtp, 999999); validate()" />                            
                                        <div class="withdraw-otp-row">
                                        <div class="otp-resend"> 
                                            <span v-if="minutes > 0 || seconds > 0">{{ minutes }}:{{ seconds }}</span> 
                                            <button v-if="isResentOtpBtnVisiable" @click.prevent="resendOtp()" :disabled="loading">{{ $t('resend-otp', 'Resend OTP') }}</button>
                                        </div>
                                    </div>
                                </div>

                                <section v-if="isOtpApiCalled && init.otp && checkValidation?.otp?.length > 0">
                                    <section v-for="(err, index) in checkValidation?.otp" :key="index">
                                        <p class="error-messages-text">{{ $t(err.lang, err.error) }}</p>
                                    </section>
                                </section>
                            </div>

                            <div class="number-header mb-3">
                                <label for="">{{ $t('withDraw-password','Withdraw Password') }}*</label>
                                <div class="password-field-rel">
                                    <input v-model="withdraw.password" :type="withdrawPasswordFieldType" placeholder="Enter Withdraw Password" class="form-control"
                                        @input="withdraw.password = $helper.sanitizeDetails('withdrawPassword', withdraw.password, 20); validate()" 
                                        :class="isOtpApiCalled && init.password && checkValidation?.withdrawPassword?.length > 0 ? 'error-input' : ''" />
                                    <div class="showHide-icon" @click="togglePasswordVisibility('withdrawPassword')">
                                        <i v-if="withdrawPasswordFieldType === 'password'" aria-hidden="true" class="fa fa-eye-slash"></i>
                                        <i v-else aria-hidden="true" class="fa fa-eye"></i>
                                    </div>
                                </div>
                                <section v-if="isOtpApiCalled && init.password && checkValidation?.withdrawPassword?.length > 0">
                                    <section v-for="(err, index) in checkValidation?.withdrawPassword" :key="index">
                                        <p class="error-messages-text">{{ $t(err.lang, err.error) }}</p>
                                    </section>
                                </section>
                            </div>


                            <div class="number-header mb-3">
                                <label for="">Confirm Withdraw Password*</label>
                                <div class="password-field-rel">
                                    <input v-model="withdraw.confirmPassword" :type="confirmPasswordFieldType" placeholder="Enter Confirm Withdraw Password" class="form-control"
                                        @input="withdraw.confirmPassword = $helper.sanitizeDetails('withdrawPassword', withdraw.confirmPassword, 20); validate()" />
                                    <div class="showHide-icon" @click="togglePasswordVisibility('newPassword')">
                                        <i v-if="confirmPasswordFieldType === 'password'" aria-hidden="true" class="fa fa-eye-slash"></i>
                                        <i v-else aria-hidden="true" class="fa fa-eye"></i>
                                    </div>
                                </div>
                                <section v-if="isOtpApiCalled && init.c_password && checkValidation?.confirmWithdrawPassword?.length > 0">
                                    <section v-for="(err, index) in checkValidation?.confirmWithdrawPassword" :key="index">
                                        <p class="error-messages-text">{{ $t(err.lang, err.error) }}</p>
                                    </section>
                                </section>
                            </div>
                        </div>
                        
                        <button @click.prevent="validateOtp()" type="button" class="btn_submit_cl">{{ $t('submit','Submit') }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import validate from '@/modules/authorization/services/authValidation';
import {resetWithdrawalPassword, openWithdrawPasswordModal, startWithdrawTimer} from "@template/utils"
export default {
    name: 'ForgotWithdrawPassword',
    props:{
        triggerAddAccountMethod: Function
    },
    data(){
        return{
            withdraw:{
                passwordOtp: null,
                password: null,
                confirmPassword: null,
            },
            isPasswordSubmit: false,
            withdrawPasswordError: null,

            isResentOtpBtnVisiable : false,
            timeLeft: 0,
            timer: null,

            validationErrors : null,
            withdrawPasswordFieldType : 'password',
            confirmPasswordFieldType: 'password',
            isOtpApiCalled:false,
            init:{
                otp:false,
                c_password:false,
                password:false
            },
            loading:false
        }
    },
    computed:{
        minutes() {
            return Math.floor(this.timeLeft / 60).toString().padStart(2, '0');
        },
        seconds() {
            return (this.timeLeft % 60).toString().padStart(2, '0');
        },
        checkValidation() {
			return this.validationErrors;
		}
    },
    methods:{
        async resendOtp(){
            this.loading = true
            try {
                let response = await openWithdrawPasswordModal()
                this.loading = false
                if(!response?.error){
                    this.resetTimer()
                }
            } catch (error) {
                this.loading = false
                this.$errorToast(error);
            }
        },
        async startTimer() {
            startWithdrawTimer((data) => {
                this.isResentOtpBtnVisiable = data.isResentOtpBtnVisiable;
                this.timeLeft = data.timeLeft;
                this.timer = data.timer;
            });
        },
        resetTimer() {
            this.isResentOtpBtnVisiable = false;
            clearInterval(this.timer);
            this.timeLeft = 5 * 60;
            this.startTimer();
        },
        validate(){
            this.validationErrors = validate.areFieldsValid(
                'withdraw-password',
				this.withdraw.passwordOtp, 
				this.withdraw.password,
				this.withdraw.confirmPassword,
            );
            return this.validationErrors;                                                                                                    
        },
        async resetWithdrawForm(){
            this.withdraw ={
                phone: '',
                passwordOtp: '',
                password: '',
                confirmPassword: ''
            },
            this.isOtpApiCalled = false;
            this.validationErrors = null;
            this.toggleInit(false)
        },
        otpHasBeenCalled(){
            this.isOtpApiCalled = true;
        },
        toggleInit(bool){
            this.init={
                otp:bool,
                c_password:bool,
                password:bool
            }
        },
        togglePasswordVisibility(fieldName) {
            if(fieldName == 'withdrawPassword'){
                this.withdrawPasswordFieldType = this.withdrawPasswordFieldType === 'password' ? 'text' : 'password';
            } else{
                this.confirmPasswordFieldType = this.confirmPasswordFieldType === 'password' ? 'text' : 'password';
            }
        },
        async validateOtp() {
            this.toggleInit(true);
            if (Object.keys(this.validate())?.filter(key => !['newPassword', 'newUserId'].includes(key))?.length !== 0) return;
            const resetResponse = await this.resetWithdrawalPassword()
            // if withdrawal password reset fails, return immediately
            if (resetResponse.error) {
                this.$errorToast(resetResponse?.error);
                if(resetResponse?.error?.[0]?.includes('OTP Expired')){
                    this.isResentOtpBtnVisiable = true;
                    clearInterval(this.timer);
                    this.timeLeft = 0;
                }
                return;
            }
            else{
                await this.resetWithdrawForm();
                this.$helper.closeModal('newUserWithDrawPasswordModel');
                this.resetTimer();
            }
        },
        async resetWithdrawalPassword(){
            if (!this.withdraw.password || this.withdraw.password == null) {
                this.$errorToast("New Withdraw Password Required!");
                return; 
            }
            if (this.withdraw.password != this.withdraw.confirmPassword) {
                this.$errorToast("Confirm Withdraw Password Does Not Match With New Withdraw Password");
                return;
            }
            let data = {
                otp: this.withdraw.passwordOtp,
                password: this.withdraw.password,
            }
            let response = await resetWithdrawalPassword(data)
            if(response?.error) return {error : response.error}
            else return true
        },
    }
}
</script>